import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import language from "./utils/language";

import "core-js/stable";
import "regenerator-runtime/runtime";

import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
Vue.use(VueSlickCarousel);

import "vue-smooth-picker/dist/css/style.css";
import SmoothPicker from "vue-smooth-picker";
Vue.use(SmoothPicker)

import Argon from "./plugins/argon-kit";
Vue.use(Argon);

import VueSocialSharing from 'vue-social-sharing'
Vue.use(VueSocialSharing);

import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
import VueSweetalert2 from 'vue-sweetalert2';
Vue.use(VueSweetalert2);

Vue.use(VuePersianDatetimePicker, {
  name: 'custom-date-picker',
  props: {
    inputFormat: 'YYYY-MM-DD',
    format: 'jYYYY-jMM-jDD',
    editable: false,
    inputClass: 'form-control my-custom-class-name',
    placeholder: '',
    altFormat: 'YYYY-MM-DD',
    color: '#00FFFF',
    autoSubmit: true,
  }
});

Vue.use(require('vue-jalali-moment'));

import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
const vuetifyOptions = {
  rtl: true,
  dark: true,
  icons: {
    iconfont: "mdi",
  },
};
Vue.use(Vuetify)

Vue.config.productionTip = false;
router.afterEach((to, from) => {
  Vue.nextTick(() => {
    document.title = 'Visternet | ' + language.lang(to.meta.title);
  });
});
new Vue({
  router,
  render: h => h(App),
  vuetify: new Vuetify(vuetifyOptions),
}).$mount("#app");
